import React from 'react';
import { observer } from 'mobx-react';
import { UnauthorizedTemplate } from 'themes/common/pages';
import { useStores } from 'core/stores/StoreContext';

const Unauthorized = observer((props) => {
    const rootStore = useStores();
    return <UnauthorizedTemplate {...props} rootStore={rootStore} />;
});

export default Unauthorized;
